import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["type", "id", "placeholder", "required", "value"]

import { computed } from 'vue';

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'InputField',
  props: {
    label: null,
    id: null,
    type: null,
    placeholder: null,
    isRequired: { type: Boolean },
    modelValue: null,
    className: null
  },
  setup(__props: any) {

const {
  label,
  id,
  type = 'text',
  placeholder = '',
  isRequired = false,
  modelValue,
} = __props as {
  label: string;
  id: string;
  type?: string;
  placeholder?: string;
  isRequired?: boolean;
  modelValue?: any;
  className?: string;
};

 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: __props.id,
      class: "block w-fit mb-2 text-sm font-medium text-gray-900 dark:text-white"
    }, _toDisplayString(__props.label), 9, _hoisted_2),
    _createElementVNode("input", {
      type: __props.type,
      id: __props.id,
      class: _normalizeClass([__props.className, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500"]),
      placeholder: __props.placeholder,
      required: __props.isRequired,
      value: __props.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
      onChecked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }, null, 42, _hoisted_3)
  ]))
}
}

})